var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00025 6.49976C4.74425 6.49976 4.48825 6.40176 4.29325 6.20676L0.29325 2.20676C-0.09775 1.81576 -0.09775 1.18376 0.29325 0.792762C0.68425 0.401762 1.31625 0.401762 1.70725 0.792762L5.01225 4.09776L8.30525 0.917762C8.70425 0.534762 9.33525 0.545762 9.71925 0.942762C10.1032 1.33976 10.0922 1.97376 9.69525 2.35676L5.69525 6.21876C5.50025 6.40676 5.25025 6.49976 5.00025 6.49976Z",
    fill: "#100F15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomArrowIcon);
export default __webpack_public_path__ + "static/media/bottomArrowIcon.b7d96d79604a84c9d16b53f08db2e0a2.svg";
export { ForwardRef as ReactComponent };